var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsPv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.135498 18.0868C0.507748 20.9439 1.63412 23.5635 3.30769 25.7408L11.8261 18.0868H0.135498Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.913 31.8646V20.174L6.25903 28.6924C8.43635 30.366 11.056 31.4924 13.913 31.8646V31.8646Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.913 0.135437C11.056 0.507687 8.43635 1.63406 6.25903 3.30762L13.913 11.8261V0.135437Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.135498 13.913H11.8261L3.30762 6.25903C1.63406 8.43629 0.507686 11.056 0.135498 13.913V13.913Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.087 0.135437V11.8261L25.7412 3.30762C23.5638 1.63419 20.9442 0.507625 18.087 0.135437V0.135437Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 13.913C31.4923 11.056 30.366 8.43628 28.6924 6.25897L20.174 13.913H31.8646Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.174 18.0868L28.6925 25.7409C30.366 23.5635 31.4924 20.9439 31.8646 18.0868H20.174Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.087 31.8646C20.9441 31.4923 23.5638 30.366 25.7411 28.6923L18.087 20.174V31.8646Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6935 25.7423L18.9514 16.0001L18.9513 16L28.6935 6.25777C28.2734 5.71177 27.8138 5.18652 27.3136 4.68627C26.8135 4.18615 26.2882 3.72646 25.7421 3.3064L16 13.0486H15.9999L6.25771 3.3064C5.71171 3.72652 5.1864 4.18608 4.68615 4.68627C4.18602 5.18652 3.72634 5.71177 3.30627 6.25783L13.0485 16L13.0485 16L3.30634 25.7423C3.72646 26.2882 4.18609 26.8135 4.68621 27.3138C5.1864 27.8139 5.71171 28.2736 6.25777 28.6936L15.9999 18.9515L25.7421 28.6936C26.2881 28.2735 26.8134 27.8139 27.3136 27.3138C27.8138 26.8135 28.2734 26.2882 28.6935 25.7423V25.7423Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 31.8646V18.0871V18.087H31.8646C31.9536 17.4038 32 16.7073 32 16C32 15.2928 31.9536 14.5963 31.8646 13.9131H18.0871L18.087 13.9131V0.1355C17.4039 0.0465625 16.7074 0 16 0C15.2927 6.25e-05 14.5962 0.0465625 13.9131 0.1355L13.9131 13.9129V13.9131H0.1355C0.0465 14.5962 0 15.2927 0 16C6.25e-05 16.7074 0.0465 17.4038 0.1355 18.0869H13.913L13.9131 31.8646C14.5962 31.9535 15.2926 32 16 32C16.7074 32 17.4039 31.9535 18.0869 31.8646V31.8646Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsPv);
export default __webpack_public_path__ + "static/media/ES-PV.c884e668.svg";
export { ForwardRef as ReactComponent };